// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O5Br69IOYkzx3XmFohE4{justify-content:flex-end;align-items:center;display:flex}.Kv2eCBy5Wc9b3K4IPh1b{min-height:32px;color:var(--content-primary-tertiary);flex:0 0 125px}.spMctt8gTk8u53FlNb7C{width:100%;margin-left:125px}.SBK6PoSs9tQarTYmVrH1{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `O5Br69IOYkzx3XmFohE4`,
	"label": `Kv2eCBy5Wc9b3K4IPh1b`,
	"trigger": `spMctt8gTk8u53FlNb7C`,
	"wrapPlaceholder": `SBK6PoSs9tQarTYmVrH1`
};
export default ___CSS_LOADER_EXPORT___;
